var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 13.25,
  stroke: "#333",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "m30.547 23.582-4.42-4.339a.854.854 0 0 0-1.195.003.826.826 0 0 0 .003 1.18l2.966 2.913H17.846a.84.84 0 0 0-.846.834c0 .46.379.834.846.834H27.9l-2.966 2.913a.827.827 0 0 0-.003 1.18.854.854 0 0 0 1.196.003l4.418-4.339a.83.83 0 0 0 0-1.182"
})));
export { SvgIconRightArrow as ReactComponent };